<template>
  <div class="menuCollapse">
    <span v-show="!isCollapse" class="sw-iconfont sw-icon-shouqi menuCollapseIcon" @click="onMenuToggle"></span>
    <span v-show="isCollapse" class="sw-iconfont sw-icon-zhankai menuCollapseIcon" @click="onMenuToggle"></span>
  </div>
</template>

<script lang="ts" setup>
  import {storeToRefs} from "pinia";
  import {menu} from '@/pinia/menu';

  const menuStore = menu();
  const {isCollapse} = storeToRefs(menuStore);

  const onMenuToggle = () => {
    menuStore.toggleCollapseStatus();
  };

</script>

<style lang="scss" scoped>
  .menuCollapse {
    font-size: 20px;
    .menuCollapseIcon {
      cursor: pointer;
    }

  }
</style>
